import { render, staticRenderFns } from "./StaffProducts.vue?vue&type=template&id=327ac5f4&scoped=true"
import script from "./StaffProducts.vue?vue&type=script&lang=js"
export * from "./StaffProducts.vue?vue&type=script&lang=js"
import style0 from "./StaffProducts.vue?vue&type=style&index=0&id=327ac5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ac5f4",
  null
  
)

export default component.exports